import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-168381ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "row d-flex align-items-center" }
const _hoisted_4 = { class: "col-1" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "col-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "col-1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "me-1" }
const _hoisted_16 = { class: "col-1" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "me-1" }
const _hoisted_19 = { class: "col-1" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "me-1" }
const _hoisted_22 = { class: "col-1" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "me-1" }
const _hoisted_25 = { class: "col-2" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "me-1" }
const _hoisted_28 = {
  key: 0,
  class: "mt-3"
}

import { onMounted, ref } from "vue";
import AccountStat from "./AccountStat.vue";
import AccountService from "../services/AccountService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import BalanceShow from "@/components/BalanceShow.vue";
import ViewRebateStat from "@/projects/tenant/modules/accounts/components/modal/ViewRebateStat.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountStat',
  props: {
    uid: {},
    from: {},
    to: {},
    viewClient: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(false);
const items = ref<any[]>([]);
const selectedAccount = ref<any>(null);
const viewClientAccount = ref(false);

const fetchData = async () => {
  isLoading.value = true;
  try {
    items.value = await AccountService.getChildAccountStat({
      uid: props.uid,
      from: props.from,
      to: props.to,
      viewClient: props.viewClient,
    });
  } catch (e) {
    MsgPrompt.error(e);
  }

  isLoading.value = false;
};

const showStatus = (_selectAccount: any) => {
  if (selectedAccount.value == _selectAccount) {
    selectedAccount.value = null;
    viewClientAccount.value = false;
  } else {
    selectedAccount.value = _selectAccount;
    if (_selectAccount == 0) {
      viewClientAccount.value = true;
    }
  }
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoadingRing)
        ]))
      : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["mb-3 pointArea p-3", 
          item.uid == selectedAccount.value || selectedAccount.value == null ? '' : 'hide'
        ]),
              key: index,
              style: {"list-style":"none"}
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, [
                    (!props.viewClient)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-sm btn-icon btn-light-primary me-2",
                          style: {"height":"20px"},
                          onClick: ($event: any) => (showStatus(item.uid))
                        }, [
                          (item.uid == selectedAccount.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Hide"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, "View"))
                        ], 8, _hoisted_5))
                      : _createCommentVNode("", true)
                  ]),
                  (item.uid != 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.uid), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "Direct Client"))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (item.uid != 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.group), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "--"))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (Object.keys(item.depositAmounts).length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.depositAmounts, (value, key) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "badge badge-primary",
                            key: key
                          }, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t(`type.currency.${key}`)), 1),
                            _createVNode(BalanceShow, {
                              "currency-id": Number(key),
                              balance: value
                            }, null, 8, ["currency-id", "balance"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (Object.keys(item.withdrawalAmounts).length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.withdrawalAmounts, (value, key) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "badge badge-warning",
                            style: {"color":"black"},
                            key: key
                          }, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t(`type.currency.${key}`)), 1),
                            _createVNode(BalanceShow, {
                              "currency-id": Number(key),
                              balance: value
                            }, null, 8, ["currency-id", "balance"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (Object.keys(item.netAmounts).length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.netAmounts, (value, key) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: _normalizeClass(["badge", value > 0 ? 'badge-success' : 'badge-danger']),
                            key: key
                          }, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t(`type.currency.${key}`)), 1),
                            _createVNode(BalanceShow, {
                              "currency-id": Number(key),
                              balance: value
                            }, null, 8, ["currency-id", "balance"])
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (Object.keys(item.profitAmounts).length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.profitAmounts, (value, key) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: _normalizeClass(["badge", value > 0 ? 'badge-success' : 'badge-danger']),
                            key: key
                          }, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t(`type.currency.${key}`)), 1),
                            _createVNode(BalanceShow, {
                              "currency-id": Number(key),
                              balance: value
                            }, null, 8, ["currency-id", "balance"])
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  (Object.keys(item.rebateAmounts).length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rebateAmounts, (value, key) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "badge badge-secondary me-2",
                            key: key
                          }, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t(`type.currency.${key}`)), 1),
                            _createVNode(BalanceShow, {
                              "currency-id": Number(key),
                              balance: value
                            }, null, 8, ["currency-id", "balance"])
                          ]))
                        }), 128)),
                        (!props.viewClient)
                          ? (_openBlock(), _createBlock(ViewRebateStat, {
                              key: 0,
                              item: item,
                              from: props.from,
                              to: props.to
                            }, null, 8, ["item", "from", "to"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2))
          }), 128)),
          (selectedAccount.value != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(AccountStat, {
                  uid: selectedAccount.value == 0 ? props.uid : selectedAccount.value,
                  from: props.from,
                  to: props.to,
                  viewClient: viewClientAccount.value
                }, null, 8, ["uid", "from", "to", "viewClient"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})